import { getHeaders } from '../../helpers/request/getHeaders';
import { QueryConfig } from 'redux-query';
import { IProfile } from '../../interfaces/Profile';

interface IRequestData {
    type: string;
    body?: any;
    queryKey?: string;
}

interface IStoreWithActiveProfile {
    entities: {
        activeProfile: IProfile
    };
}

export const activeProfileRequest = (data: IRequestData): QueryConfig => {
    const type = 'activeProfile';
    const requestData: QueryConfig = {
        url: `${Env.API_URL}/auth/me`,
        options: {
            method: 'GET',
            headers: getHeaders(),
        },
        queryKey: data.queryKey,
        body: data.body,
    };
    return {
        ...requestData,
        transform: (response: any) => ({
            [`${type}`]: response.user as IProfile,
        }),
        update: {
            [`${type}`]: (prev: any, next: any) => {
                return next;
            },
        },
    };
};

export const activeProfileSelector = (store: IStoreWithActiveProfile) => store.entities.activeProfile;
